module.exports = __webpack_public_path__ + "img/btn_messege.0080ed98.svg";